<template>
  <div class="app-search d-none d-lg-block p-0">
    <div class="position-relative">
      <input type="text" class="form-control" :placeholder="placeholder" v-model="searchInput" />
      <span class="bx bx-search-alt"></span>
    </div>
  </div>
</template>

<script>
import { APIRequest } from '@/node-sdk'

export default {
  name: 'search-field-add',

  props: {
    placeholder: {
      type: String,
      default: 'Rechercher...',
    },
    value: Array,
    baseUrl: {
      type: String,
      required: true,
    },
    ressource: {
      type: String,
      required: true,
    },
    fields: {
      type: String,
      default: '',
    },
    limitTo: {
      type: Array,
      default: () => [],
    },
    entityLimitTo: String,
  },

  data() {
    return {
      dataValue: this.value,
      searchInput: '',
    }
  },

  watch: {
    searchInput: async function () {
      await this.searchFunction()
    },

    value: function () {
      this.dataValue = this.value
    },

    limitTo: {
      deep: true,
      async handler() {
        await this.searchFunction()
      },
    },
  },

  async mounted() {
    await this.searchFunction()
  },

  methods: {
    async searchFunction() {
      let response
      ;[response] = await APIRequest.get_with_request(
        this.baseUrl,
        this.ressource,
        `?search=${this.searchInput}&fields=${this.fields}`,
      )
      this.dataValue = []
      for (let i = 0; i < response.length; i++) {
        let inIt = false
        for (let j = 0; j < this.limitTo.length; j++) {
          if (response[i][this.entityLimitTo] === this.limitTo[j]) {
            inIt = true
          }
        }
        if (!inIt) {
          this.dataValue.push(response[i])
        }
      }
      this.$emit('input', this.dataValue)
    },
  },
}
</script>

<style scoped></style>
